import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { BaseCell, BaseHeader } from './Column';
import { Responsive } from '../../../../../../ui';

interface IGateProps {
	gate: string;
}

const styles = css`
	max-width: 130px;

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		display: none;
	}
`;

export const StyledHeader = styled(BaseHeader)`
	${styles}
`;

export const StyledCell = styled(BaseCell)`
	${styles};
	font-weight: 500;
`;

export function Header() {
	return <StyledHeader>Gate</StyledHeader>;
}

export function Cell({ gate }: IGateProps) {
	return <StyledCell>{gate || 'Not available'}</StyledCell>;
}
